import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="cfooter">
      <div className="cfooter-container">
        <p>Copyright © 2026 RTS Techsol | All Rights Reserved</p>
        {/* Avengers */}
      </div>
    </footer>
  );
};

export default Footer;
